import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material";
import { mUser, Login } from "../../models/user.model";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UserService } from "../../services/user.service";
import { fuseAnimations } from "../../../../core/animations";
import { Router } from "@angular/router";
import { Input } from "@angular/core/src/metadata/directives";

import { AppService } from "../../services/app.service";
import { ComponentService } from "../../services/component.service";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.scss"],
  animations: fuseAnimations
})
export class ChangePasswordComponent implements OnInit {
  lableData: boolean;
  translationData: any;
  isNew = false;
  isMatch: boolean;
  hide = true;
  nHide = true;
  cHide = true;
  ChangePwdForm: FormGroup;
  ChagePwdFormErrors: any;
  translations: any;
  diffOldPassword = false;
  diffConfirmPassword = false;
  invalidform = true;
  constructor(
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public login: Login,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private router: Router,
    public comService: ComponentService,
    public appService: AppService
  ) {
    this.appService.showLoading();

    this.appService.checkSession();

    this.ChagePwdFormErrors = {
      Password: {},
      LastPassword: {},
      ConfirmPassword: {}
    };

    this.login = new Login();
  }

  ngOnInit() {
    this.setPageTranslations();
    this.ChangePwdForm = this.formBuilder.group({
      Password: ["", Validators.required],
      LastPassword: ["", Validators.required],
      ConfirmPassword: ["", Validators.required]
    });

    this.ChangePwdForm.valueChanges.subscribe(() => {
      this.ChagePwdFormErrors = this.appService.onFormValuesChanged(
        this.ChangePwdForm,
        this.ChagePwdFormErrors
      );
      this.invalidform = true;
      if(!this.ChangePwdForm.invalid && !this.diffConfirmPassword && !this.diffOldPassword){
        this.invalidform = false;
      }
   
    });

    this.appService.hideLoading();
  }

  setPageTranslations() {
    this.translations = JSON.parse(sessionStorage.getItem("pageData"));
  }

  changePassword() {
    if (this.login.Password == this.login.ConfirmPassword) {
      let dataTobePosted: any = {};
      var user = new mUser();
      user.Password = this.login.OldPassword;
      user.NewPassword = this.login.Password;
      this.userService
        .changePassword(JSON.stringify(user))
        .subscribe(
          res => this.changePasswordSuccess(res),
          error => this.apiFailure(error)
        );
    } else {
      this.isMatch = true;
    }
  }
  backToLogin() {
    this.dialogRef.close();
    sessionStorage.clear();

    this.appService.checkSession();
  }
  changePasswordSuccess(res) {
    if (res["Status"] == "1") {
      this.appService
        .showDialogue(
          this.translations.hdSuccess,
          this.translations[res.Message]
        )
        .afterClosed()
        .subscribe(result => {
          if (result) {
            this.dialogRef.close();
            sessionStorage.clear();
            this.appService.checkSession();
          }
        });
    } else {
      this.apiFailure(res.Message);
    }
  }

  apiFailure(error) {
    this.appService.hideLoading();
    this.appService.showDialogue(
      this.translations.hdError,
      this.translations[error]
    );
  }
  changeType(param) {
    var inputype = document.getElementById(param);
    if (inputype.getAttribute("type") == "password") {
      inputype.setAttribute("type", "text");
    } else {
      inputype.setAttribute("type", "password");
    }
  }
  checkPassword() {
    ;
    this.diffOldPassword = false;
    if (
      typeof this.login.OldPassword != "undefined" &&
      typeof this.login.Password != "undefined"
    ) {
      if (
        this.login.OldPassword != "" &&
        this.login.Password != "" &&
        this.login.OldPassword == this.login.Password
      ) {
        this.diffOldPassword = true;
      }
    }

    if (
      typeof this.login.ConfirmPassword != "undefined" &&
      typeof this.login.Password != "undefined"
    ) {
    this.diffConfirmPassword = false;
    if (
      this.login.Password != "" &&
      this.login.ConfirmPassword != "" &&
      this.login.Password != this.login.ConfirmPassword
    ) {
      this.diffConfirmPassword = true;
    }
  }
  }
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/change-password/change-password.component.ts